import { lazy } from 'react'
// import Index from '../pages/index'
const Index = lazy(() => import('../pages/index/index'))
const Industries = lazy(() => import('../pages/Industries'))
const Product = lazy(()=> import('../pages/Product'))
const ContactUs = lazy(()=> import('../pages/ContactUs'))
const About = lazy(()=> import('../pages/about'))


const route = [
    {
        path: '/',
        key: 'Index',
        element: <Index/>,
    },
    {
        path: '/product',
        key: 'product',
        element: <Product/>,
    },
    {
        path: '/industries',
        key: 'Industries',
        element: <Industries/>,
    },
    {
        path: '/contact',
        key: 'contact',
        element: <ContactUs/>,
    },
    {
        path: '/about',
        key: 'about',
        element: <About/>,
    }
]
export default route;